import { transitionTheme } from "./preferences.js";
import { useT } from "./i18n.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { ActionIcon, useComputedColorScheme } from "@mantine/core";
import { Moon, Sun } from "lucide-react";
// src/theme/theme-toggle.tsx
/**
* Light/dark switch for every header. The choice is stored for all HLT apps.
*/
function ThemeToggle({ size = "lg" }) {
	const t = useT();
	const scheme = useComputedColorScheme("light");
	const next = scheme === "dark" ? "light" : "dark";
	const toggle = (event) => {
		const rect = event.currentTarget.getBoundingClientRect();
		transitionTheme(next, {
			x: rect.left + rect.width / 2,
			y: rect.top + rect.height / 2
		});
	};
	return /* @__PURE__ */ jsxs(ActionIcon, {
		variant: "subtle",
		color: "gray",
		size,
		onClick: toggle,
		"aria-label": next === "dark" ? t("common.switchToDark") : t("common.switchToLight"),
		title: next === "dark" ? t("common.switchToDark") : t("common.switchToLight"),
		className: "hlt-theme-toggle",
		"data-scheme": scheme,
		children: [/* @__PURE__ */ jsx(Sun, {
			"aria-hidden": true,
			className: "hlt-theme-toggle-sun size-5"
		}), /* @__PURE__ */ jsx(Moon, {
			"aria-hidden": true,
			className: "hlt-theme-toggle-moon size-5"
		})]
	});
}
export { ThemeToggle as t };

//# sourceMappingURL=theme-toggle-gP7w4XRa.js.map